import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["input", "label"]

  connect() {
    this.countriesWithProvinceSelect = this.inputTargets.map(el => el.dataset.country)
  }

  // outlet API: read by users/fields_controller via the province outlet
  get value() {
    return this.inputTargets.find(input => !input.disabled)?.value
  }

  // outlet API: called by country_controller via the province outlet
  refresh(country) {
    this.#toggleLabels(country)
    this.#toggleInputs(country)
  }

  #toggleLabels(country) {
    if (!country) {
      this.labelTargets.forEach(element => {
        element.classList.add(this.hiddenClass)
      })

      return
    }

    this.labelTargets.forEach(element => {
      const isDisabled = country !== element.dataset.country
      element.classList.toggle(this.hiddenClass, isDisabled)
    })
  }

  #toggleInputs(country) {
    const countryForProvince = this.#countryForProvince(country)
    this.inputTargets.forEach(element => {
      const isDisabled = countryForProvince !== element.dataset.country
      element.classList.toggle(this.hiddenClass, isDisabled)
      element.disabled = isDisabled
    })
  }

  #countryForProvince(country) {
    if (!country) {
      return null
    }

    if (this.countriesWithProvinceSelect.includes(country)) {
      return country
    }

    return "OTHER"
  }
}
